import { render, staticRenderFns } from "./ImportClaimReview.vue?vue&type=template&id=7b9b2423"
import script from "./ImportClaimReview.vue?vue&type=script&lang=ts"
export * from "./ImportClaimReview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports